import React, { PureComponent } from 'react'
import MessageItem from './MessageItem'

import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 18px 25px 18px;
`

class MessageList extends PureComponent {
  render() {
    const { events } = this.props

    return (
      <StyledWrapper>
        {events.map((event) => (
          <MessageItem key={event.date} event={event} />
        ))}
      </StyledWrapper>
    )
  }
}

export default MessageList
